<template>
  <div class="konfigurator">
    <div class="container">
      <div class="config-box">
        <config v-model="currentConfig" ref="configbox" @change="$emit('change'); changeModelUrl()" />
      </div>
      <div class="boxes col12">
        <div class="boxes-header">
          Ausgewählte Schnitte
        </div>
        <div class="boxes-content">
          <config-view v-for="(config, key) in configs" @select="edit(key)" :key="key" :config="config" :class="{box: true, active: key === currentConfigKey}" :id="key" @delete="remove(key)" />
          <div class="box add-box" @click="add" title="Weiteren Schnitt hinzufügen">
            <i class="icon-plus"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Config from '@/components/Config'
import ConfigView from '@/components/ConfigView'

export default {
  name: 'Konfigurator',
  components: {
    Config,
    ConfigView
  },
  data () {
    window.konfigurator = this
    let startConfig = {}
    return {
      configs: {'c0': startConfig},
      nextId: 1,
      currentConfig: startConfig,
      currentConfigKey: 'c0',
      count: 1
    }
  },
  methods: {
    changeModelUrl () {
      this.$emit('modelChange', this.$refs.configbox.modelName)
    },
    add () {
      let key = 'c' + this.nextId
      this.count += 1
      this.nextId += 1
      this.$set(this.configs, key, {})
      this.edit(key)
      this.$emit('change')
    },
    remove (delKey) {
      if (this.count === 1) {
        this.add()
      } else {
        this.edit(Object.keys(this.configs).find(k => k !== delKey))
      }
      this.count -= 1
      this.$delete(this.configs, delKey)
      this.$emit('change')
    },
    edit (key) {
      this.configs[this.currentConfigKey] = this.currentConfig
      this.currentConfigKey = key
      this.currentConfig = this.configs[this.currentConfigKey]
      this.$nextTick(() => this.$refs.configbox.defaultTab())
    },
    getSchnitte () {
      return Object.values(this.configs)
    },
    setSchnitte (data) {
      this.currentConfig = undefined
      this.currentConfigKey = undefined
      console.log(data)
      for (let key in this.configs) {
        this.$delete(this.configs, key)
      }
      this.count = 0
      this.nextId = 0
      for (let config of data) {
        this.$set(this.configs, 'c' + this.nextId, config)
        this.count += 1
        this.nextId += 1
      }
      this.currentConfigKey = 'c0'
      this.currentConfig = this.configs['c0']
      this.$nextTick(() => this.$refs.configbox.defaultTab())
    }
  },
  mounted () {
  },
  computed: {
  }
}
</script>

<style scoped lang="scss">

.boxes-header {
  height: 48px;
  line-height: 48px;
  text-align: left;
  float: left;
  font-size: 15px;
  padding-left: 30px;
  display: none;
  @media screen and (min-width: 768px) {
    width: 30%;
    display: block;
  }
  @media screen and (min-width: 1024px) {
    width: 25%;
  }
  @media screen and (min-width: 1100px) {
    width: 20%;
  }
}

.boxes-content {
  width: 100%;
  @media screen and (min-width: 768px) {
    float: left;
    width: 70%;
  }
  @media screen and (min-width: 1024px) {
    width: 75%;
  }
  @media screen and (min-width: 1100px) {
    width: 80%;
  }
}

.boxes {
  margin-top: -25px;
}

.box {
  height: 48px;
  float: left;
  cursor: pointer;
  background-color: white;
  text-align: center;
  padding: 0 24px;
  line-height: 48px;
  margin-right: 5px;
  margin-bottom: 5px;
}

.box.active {
  background-color: #ec6608;
  color: white;
  font-weight: bold;
}

.add-box {
  background-color: transparent;
  padding: 2px 14px 0;
}

.add-box > .plus-icon {
  color: #ec6608;
  font-size: 19px;
  line-height: 48px;
}

.add-box:hover > .plus-icon {
  color: #d85200;
}

</style>



// WEBPACK FOOTER //
// src/components/Konfigurator.vue